var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline-block" } },
    [
      _c(
        "el-dropdown",
        {
          attrs: {
            "split-button": "",
            title: _vm.replyTicketButtonTitle,
            type: _vm.replyTicketButtonType
          },
          on: {
            click: _vm.onReplyTicket,
            "visible-change": _vm.onVisibleChange,
            command: _vm.onDropdownItem
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.replyTicketButtonText) + "\n    "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            [
              _c(
                "el-dropdown-item",
                {
                  attrs: {
                    command: "privateReply",
                    title:
                      "私密回复仅对后台用户可见 ( 在各端老版本的工单界面, 仍可能所有人可见 )"
                  }
                },
                [_vm._v("私密回复 (提交本次)")]
              ),
              _vm._v(" "),
              _c(
                "el-dropdown-item",
                {
                  attrs: {
                    command: "publicReply",
                    title:
                      "公开回复对淘金客可见 ( 如果此淘金客是当前工单的创建人的话 )"
                  }
                },
                [_vm._v("公开回复 (提交本次)")]
              ),
              _vm._v(" "),
              _c("el-dropdown-item", { attrs: { command: "switchPrivate" } }, [
                _vm._v(
                  "切换为 默认 " +
                    _vm._s(
                      "公开回复" == _vm.replyTicketButtonText
                        ? "私密回复"
                        : "公开回复"
                    )
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "提示", visible: _vm.dialogObj.show, width: "330px" },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialogObj, "show", $event)
            }
          }
        },
        [
          _vm.dialogObj.step == 1
            ? [
                _c("span", [_vm._v("是否需要修改工单状态？")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onDirectReplyTicket }
                      },
                      [_vm._v("直接回复")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.dialogObj.step = 2
                          }
                        }
                      },
                      [_vm._v("修改状态并回复")]
                    )
                  ],
                  1
                )
              ]
            : [
                _c("TicketStatusSelect", {
                  on: {
                    change: function(res) {
                      return (_vm.dialogObj.status = res)
                    }
                  },
                  model: {
                    value: _vm.dialogObj.status,
                    callback: function($$v) {
                      _vm.$set(_vm.dialogObj, "status", $$v)
                    },
                    expression: "dialogObj.status"
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.dialogObj.step = 1
                          }
                        }
                      },
                      [_vm._v("上一步")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onUpdateStatusAndReplyTicket }
                      },
                      [_vm._v("确定")]
                    )
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57ae3295", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57ae3295","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/ReplyTicketButton.vue
// module id = 802
// module chunks = 75